var jcsfApp;
(function (jcsfApp) {
    var app;
    (function (app) {
        var auth;
        (function (auth) {
            var authService = (function () {
                function authService(httpService, constantService, dataService, qService, permissionService, $cookieStore) {
                    this.httpService = httpService;
                    this.constantService = constantService;
                    this.dataService = dataService;
                    this.qService = qService;
                    this.permissionService = permissionService;
                    this.userInfo = null;
                    this.$cookieStore = $cookieStore;
                    this.authentication = { isAuth: false, userName: '', userInfo: {}, background: "" };
                }
                authService.prototype.loginfs = function (userName) {
                    var self = this;
                    var deferred = this.qService.defer();
                    const logindata = {
                        username: userName,
											password: ""
                     };
                    this.httpService.post('/api/auth/logonfs', logindata).success(function (response) {
                        if (response.authenticated === false) {
                            self.logOut();
                            self.authentication.isAuth = false;
                            deferred.reject("Not Authorized");
                        }
                        else if (!response.userInfo || !response.userInfo.UserId) {
                            self.logOut();
                            self.authentication.isAuth = false;
                            deferred.reject("Not Authorized");
                        }
                        else {
                            var userInfo = { token: response.access_token, userName: response.userName, userInfo: response.userInfo, roles: response.roles };
                            self.permissionService.setPermissions(response.roles);
                            window.localStorage.setItem('authenticationInfo', JSON.stringify(userInfo));
                            self.authentication.isAuth = true;
                            self.authentication.userName = userInfo.userName;
                            self.authentication.userInfo = userInfo.userInfo;
                            console.info(userInfo)
                            self.httpService.defaults.headers.common["Authorization"] = 'Basic ' + response.access_token;
                            self.$cookieStore.put('user', response.userInfo);
                            deferred.resolve(response);
                        }
                    }).error(function (err, status) {
                        self.logOut();
                        deferred.reject(err);
                    });
                    return deferred.promise;
                };
                authService.prototype.login = function (loginData) {
                    var self = this;
                    var deferred = this.qService.defer();
                    this.httpService.post('/api/auth/logon', loginData).success(function (response) {
                        if (response.authenticated === false) {
                            self.logOut();
                            self.authentication.isAuth = false;
                            deferred.reject("Not Authorized");
                        }
                        else if (!response.userInfo || !response.userInfo.UserId) {
                            self.logOut();
                            self.authentication.isAuth = false;
                            deferred.reject("Not Authorized");
                        }
                        else {
                            var userInfo = { token: response.access_token, userName: response.userName, userInfo: response.userInfo, roles: response.roles };
                            self.permissionService.setPermissions(response.roles);
                            window.localStorage.setItem('authenticationInfo', JSON.stringify(userInfo));
                            self.authentication.isAuth = true;
                            self.authentication.userName = userInfo.userName;
                            self.authentication.userInfo = userInfo.userInfo;
                            console.info('userInfo', userInfo)
                            self.httpService.defaults.headers.common["Authorization"] = 'Basic ' + response.access_token;
                            self.$cookieStore.put('user', response.userInfo);
                            deferred.resolve(response);
                        }
                    }).error(function (err, status) {
                        self.logOut();
                        deferred.reject(err);
                    });
                    return deferred.promise;
                };
                authService.prototype.init = function () { };
                authService.prototype.LogoutData = function (userObj) {
                    this.httpService.post('/api/auth/logout', userObj);
                };
                authService.prototype.logOut = function () {

                    this.httpService.defaults.headers.common["Authorization"] = 'Basic' + '';

                    this.authentication.isAuth = false;
                    window.localStorage.clear();
                };
                authService.prototype.saveRegistration = function (registration) {
                    return this.httpService.post(this.constantService.apiProfileURI + "signup", registration).then(function (response) { return response; });
                };
                authService.prototype.updateProfile = function (profile) {
                    var authData = JSON.parse(window.localStorage.getItem('authenticationInfo'));
                    authData.userInfo = profile;
                    window.localStorage.setItem('authenticationInfo', JSON.stringify(authData));
                    $("#success-alert").alert();
                    $("#success-alert").fadeTo(2000, 500).slideUp(500, function () {
                        $("#success-alert").alert('close');
                    });
                    this.fillAuthData();
                };
                authService.prototype.fillAuthData = function () {
                    var authData = JSON.parse(window.localStorage.getItem('authenticationInfo'));
                    if (authData) {
                        console.info('authData', authData.userInfo);
                        this.authentication.isAuth = true;
                        this.authentication.userName = authData.UserName || authData.userName;
                        this.authentication.userInfo = authData.userInfo;
                        console.info('authentication.userInfo', this.authentication.userInfo);
                    }
                };
                authService.$inject = ['$http', "constantService", "dataService", "$q", "PermissionService", "$cookieStore"];
                return authService;
            })();
            auth.authService = authService;
            angular.module("jcsfApp")
                .service("authService", jcsfApp.app.auth.authService);
        })(auth = app.auth || (app.auth = {}));
    })(app = jcsfApp.app || (jcsfApp.app = {}));
})(jcsfApp || (jcsfApp = {}));
